import React, { useState } from 'react';

const StartProjectPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    platform: 'Web App (SaaS)',
    budget: '$5k - $10k',
    brief: ''
  });

  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: 'loading', message: 'INITIALIZING...' });

    try {
      const response = await fetch('https://toporion.net/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      console.log(response)

      if (response.ok) {
        setStatus({ type: 'success', message: 'PROTOCOL SENT' });
        setFormData({ name: '', email: '', platform: 'Web App (SaaS)', budget: '$5k - $10k', brief: '' });
      } else {
        setStatus({ type: 'error', message: 'ERROR: RETRY' });
      }
    } catch (error) {
      setStatus({ type: 'error', message: 'SERVER OFFLINE' });
    }
  };

  const steps = [
    { id: "01", phase: "DISCOVERY & INTEL", icon: "🔍", desc: "We define user personas and establish success metrics before writing code." },
    { id: "02", phase: "SYSTEM BLUEPRINT", icon: "📐", desc: "We architect the database schema and choose the right stack (MERN/Next.js)." },
    { id: "03", phase: "AGILE BUILD CYCLES", icon: "⚙️", desc: "2-week sprints with live preview links. Transparency at every stage." },
    { id: "04", phase: "LAUNCH & SCALE", icon: "🚀", desc: "Rigorous QA testing, security audits, and final deployment to production." }
  ];

  return (
    <div className="min-h-screen bg-[#0f172a] text-white pt-24 pb-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full bg-[linear-gradient(to_right,#80808008_1px,transparent_1px),linear-gradient(to_bottom,#80808008_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h1 className="text-4xl md:text-6xl font-black font-display text-white mb-6">
            THE ENGAGEMENT <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00F0FF] to-purple-500">PROTOCOL</span>
          </h1>
          <p className="text-gray-400 text-lg leading-relaxed">
            Our standardized path from "idea" to "shipped product."
          </p>
        </div>

        <div className="mb-24 grid grid-cols-1 md:grid-cols-4 gap-6 relative z-10">
          {steps.map((step) => (
            <div key={step.id} className="bg-[#18181b]/50 border border-white/5 p-6 rounded-xl hover:border-[#00F0FF]/30 transition-all text-center group">
              <div className="text-3xl mb-4 group-hover:scale-110 transition-transform">{step.icon}</div>
              <h3 className="text-sm font-bold text-white mb-2 font-display tracking-wider">{step.phase}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="bg-[#18181b] border border-[#00F0FF]/20 rounded-3xl shadow-[0_0_50px_rgba(0,240,255,0.1)] relative overflow-hidden grid grid-cols-1 lg:grid-cols-5">
            
            <div className="lg:col-span-2 relative min-h-[300px] lg:min-h-full">
              <img 
                src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=2670&auto=format&fit=crop" 
                alt="System Source Code" 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] via-[#0f172a]/80 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-[#0f172a]/80 lg:to-[#18181b]"></div>
              <div className="absolute bottom-0 left-0 p-8 md:p-12 z-10">
                <h3 className="text-2xl font-black font-display text-white mb-2 uppercase tracking-tighter">Human Support Available</h3>
                <p className="text-gray-300 text-sm">Submit your brief below, or use the direct channels if you need an immediate consultation.</p>
              </div>
            </div>

            <div className="lg:col-span-3 p-8 md:p-12 relative flex flex-col justify-between">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00F0FF] to-transparent animate-pulse lg:hidden"></div>
              
              <form className="space-y-6 mb-12" onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="group">
                    <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest group-focus-within:text-[#00F0FF] transition-colors">// Name</label>
                    <input type="text" name="name" required value={formData.name} onChange={handleChange} className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-white focus:outline-none focus:border-[#00F0FF] transition-all font-mono text-sm" placeholder="John Doe" />
                  </div>
                  <div className="group">
                    <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest group-focus-within:text-[#00F0FF] transition-colors">// Email</label>
                    <input type="email" name="email" required value={formData.email} onChange={handleChange} className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-white focus:outline-none focus:border-[#00F0FF] transition-all font-mono text-sm" placeholder="john@company.com" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="group">
                    <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest group-focus-within:text-[#00F0FF] transition-colors">// Platform</label>
                    <select name="platform" value={formData.platform} onChange={handleChange} className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-gray-300 focus:outline-none focus:border-[#00F0FF] transition-all font-mono appearance-none cursor-pointer text-sm">
                      <option>Web App (SaaS)</option>
                      <option>E-Commerce</option>
                      <option>Mobile App</option>
                    </select>
                  </div>
                  <div className="group">
                    <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest group-focus-within:text-[#00F0FF] transition-colors">// Budget</label>
                    <select name="budget" value={formData.budget} onChange={handleChange} className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-white focus:outline-none focus:border-[#00F0FF] transition-all font-mono appearance-none cursor-pointer text-sm">
                      <option>$1k - $3k</option>
                      <option>$5k - $10k</option>
                      <option>$10k - $25k</option>
                      <option>$25k+</option>
                    </select>
                  </div>
                </div>

                <div className="group">
                  <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest group-focus-within:text-[#00F0FF] transition-colors">// Brief</label>
                  <textarea name="brief" required value={formData.brief} onChange={handleChange} rows="3" className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-white focus:outline-none focus:border-[#00F0FF] transition-all font-mono text-sm" placeholder="Tell us about your idea..."></textarea>
                </div>

                <button type="submit" disabled={status.type === 'loading'} className="group relative w-full py-4 bg-[#00F0FF] text-black font-bold text-base rounded-xl overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,240,255,0.5)] hover:scale-[1.01] active:scale-[0.99] disabled:bg-gray-600">
                  <span className="relative flex items-center justify-center gap-2 uppercase tracking-widest">
                    {status.message || 'INITIALIZE PROJECT'}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" /></svg>
                  </span>
                </button>
              </form>

              {/* --- DIRECT CONTACT HUB (EXPERIMENTAL PLACEMENT) --- */}
              <div className="pt-8 border-t border-white/5">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center gap-3 bg-white/5 p-3 rounded-lg border border-white/5">
                    <div className="p-2 bg-[#00F0FF]/10 rounded-lg text-[#00F0FF]">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-[9px] text-gray-500 uppercase font-mono tracking-widest">Voice</p>
                      <p className="text-xs font-bold text-gray-200">+880 1752-529602</p>
                    </div>
                  </div>

                  <a href="https://wa.me/8801752529602" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-white/5 p-3 rounded-lg border border-white/5 hover:border-green-500/30 transition-all">
                    <div className="p-2 bg-green-500/10 rounded-lg text-green-400">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.246 2.248 3.484 5.232 3.484 8.412-.003 6.557-5.338 11.892-11.893 11.892-1.997-.001-3.951-.5-5.688-1.448l-6.309 1.656zm6.224-3.52c1.54.914 3.51 1.403 5.46 1.404 5.452 0 9.889-4.437 9.892-9.891.001-2.646-1.027-5.132-2.896-7.003-1.868-1.87-4.35-2.898-6.996-2.899-5.454 0-9.891 4.438-9.894 9.892-.001 2.097.547 4.142 1.588 5.945l-1.07 3.91 4.01-1.053z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-[9px] text-gray-500 uppercase font-mono tracking-widest">WhatsApp</p>
                      <p className="text-xs font-bold text-green-400">Chat Now</p>
                    </div>
                  </a>

                  <div className="flex items-center gap-3 bg-white/5 p-3 rounded-lg border border-white/5">
                    <div className="p-2 bg-purple-500/10 rounded-lg text-purple-400">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-[9px] text-gray-500 uppercase font-mono tracking-widest">Team</p>
                      <p className="text-xs font-bold text-gray-200">salman.rokon</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartProjectPage;